<!-- Add Discounted Period Modal  -->
<p-dialog
  [visible]="showDiscountPeriodPopup()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '670px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="surface-0 sticky left-0 top-0 w-full px-3 py-2 flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <h2 class="mb-0 text-sm font-bold flex align-items-center">
        {{ 'FREEDISCOUNT.ADD_FREE_DISCOUNT' | translate }}
        @if (clientDetails.image) {
          <p-avatar [image]="clientDetails.image" shape="" styleClass="mx-2" />
        } @else {
          <p-avatar
            [label]="
              client2LetterName(clientDetails.full_name) | titlecase | shortName
            "
            shape=""
            styleClass="mx-2"
          />
        }
        <span class="text-primary cursor-pointer">{{
          clientDetails.full_name
        }}</span>
      </h2>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="closePopup()"
      ></div>
    </div>
    <!-- Header -->

    <!-- Message -->
    <div class="-my-3">
      <p-message
        severity="info"
        styleClass="relative"
        aria-label="free-discount-limitation-message"
      >
        <span
          class="ml-2"
          [innerHTML]="'FREEDISCOUNT.LIMITATION' | translate"
        ></span>
      </p-message>
    </div>
    <!-- Message -->

    <div class="p-3">
      <div class="p-buttonset">
        <p-button
          styleClass="text-sm white-space-nowrap border-right-1 border-white"
          icon="fa fa-percent"
          [label]="'FREEDISCOUNT.BTN_BY_STAFF' | translate"
        />
      </div>
    </div>

    <form [formGroup]="discountedPeriodForm" *ngIf="discountedPeriodForm">
      <!-- Modal Content -->
      <div class="p-3">
        <!-- Discount Periods List -->
        @for (
          discountedPeriod of discountedPeriods;
          track discountedPeriod;
          let i = $index
        ) {
          <div
            class="surface-0 border-1 border-300 border-round mb-2 p-3 hover:shadow-1 transition-all transition-duration-200 relative"
          >
            <!-- Remove Button - Top Right Corner -->
            <div class="absolute top-0 right-0 mt-2 mr-2">
              <p-button
                icon="fa fa-trash-alt"
                styleClass="p-button-text p-button-danger p-button-sm hover:surface-red-100"
                pTooltip="Remove"
                tooltipPosition="left"
                tooltipStyleClass="text-xs"
                (click)="
                  removeDiscountedPeriod(
                    i,
                    discountedPeriod.get('discountAcucrence').value
                      ?.occurance_start_date
                  )
                "
                [attr.aria-label]="'remove-discount'"
              />
            </div>
            <!-- Billing Cycle and Recurring Charge -->
            <div class="grid grid-nogutter mb-2">
              <div class="col-12 sm:col-6 pr-0 sm:pr-2 mb-2 sm:mb-0">
                <label
                  class="block text-xs text-600 font-semibold mb-1 uppercase"
                  >{{ 'FREEDISCOUNT.BILLING_CYCLE' | translate }}</label
                >
                <p-button
                  icon="fa fa-angle-down"
                  [label]="
                    discountedPeriod.get('discountAcucrence').value
                      ? (discountedPeriod.get('discountAcucrence').value
                          .occurance_start_date | datetimeformat: 'd MMM yy')
                      : 'Select...'
                  "
                  iconPos="right"
                  styleClass="w-full surface-0 p-button-outlined border-300 text-600 text-sm hover:border-primary"
                  (click)="selectBillingCycle.toggle($event)"
                  [ngClass]="{
                    'ng-invalid ng-dirty border-red-500':
                      discountedPeriod.get('discountAcucrence').invalid &&
                      discountedPeriod.get('discountAcucrence').touched,
                  }"
                  [attr.aria-label]="'select-billing-cycle'"
                />
                <p-popover
                  #selectBillingCycle
                  styleClass="overflow-hidden text-sm w-10rem shadow-4"
                >
                  <ng-template #content>
                    @for (billingCycle of getOccurences; track billingCycle) {
                      <ul class="list-none -m-4 px-0 py-2 text-sm text-600">
                        <li
                          (click)="
                            selectBillingCycle.toggle($event);
                            setAccurence(discountedPeriod, billingCycle)
                          "
                          class="cursor-pointer hover:surface-200 hover:text-primary py-2 px-3 transition-colors transition-duration-150"
                        >
                          {{
                            billingCycle.occurance_start_date
                              | datetimeformat: 'd MMM yy'
                          }}
                        </li>
                      </ul>
                    }
                  </ng-template>
                </p-popover>
              </div>
              <div class="col-12 sm:col-6 pl-0 sm:pl-2">
                <label
                  class="block text-xs text-600 font-semibold mb-1 uppercase"
                  >{{ 'FREEDISCOUNT.RECURRING_CHARGE' | translate }}</label
                >
                <div
                  class="flex align-items-center justify-content-start"
                  style="height: 2.357rem"
                >
                  <strong class="text-primary text-lg">{{
                    discountedPeriod.get('discountedAmount').value
                      | currencyformat
                  }}</strong>
                </div>
              </div>
            </div>
            <!-- Discount Inputs -->
            <div class="mb-2">
              <label
                class="block text-xs text-600 font-semibold mb-1 uppercase"
                >{{ 'FREEDISCOUNT.DISCOUNT' | translate }}</label
              >
              <div class="grid grid-nogutter">
                <div class="col-12 sm:col-6 pr-0 sm:pr-1 mb-2 sm:mb-0">
                  <p-inputNumber
                    mode="decimal"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    [formControl]="discountedPeriod.get('discountValue')"
                    [ngClass]="{
                      'ng-invalid ng-dirty':
                        discountedPeriod.get('discountValue').invalid ||
                        discountedPeriod.get('discountValue').errors,
                    }"
                    styleClass="w-full text-sm"
                    inputStyleClass="hover:border-primary focus:border-primary"
                    [placeholder]="'Value (0.00)'"
                    (onBlur)="
                      calculateDiscount(
                        discountedPeriod.get('discountTotalAmount'),
                        discountedPeriod.get('discountValue'),
                        discountedPeriod.get('discountPercent'),
                        discountedPeriod.get('discountedAmount')
                      )
                    "
                    [attr.aria-label]="'discount-value'"
                  />
                </div>
                <div class="col-12 sm:col-6 pl-0 sm:pl-1">
                  <div class="p-inputgroup w-full flex">
                    <span
                      class="p-inputgroup-addon mt-2 bg-primary-50 border-primary-100 white-space-nowrap"
                      ><i class="fa fa-percent text-primary"></i
                    ></span>
                    <p-inputNumber
                      [formControl]="discountedPeriod.get('discountPercent')"
                      styleClass="w-full text-sm"
                      inputStyleClass="hover:border-primary focus:border-primary"
                      [minFractionDigits]="2"
                      [maxFractionDigits]="2"
                      mode="decimal"
                      [placeholder]="'Percent (0.00)'"
                      [ngClass]="{
                        'ng-invalid ng-dirty':
                          discountedPeriod.get('discountPercent').invalid &&
                          discountedPeriod.get('discountPercent').touched,
                      }"
                      (onBlur)="
                        calculateAmount(
                          discountedPeriod.get('discountTotalAmount'),
                          discountedPeriod.get('discountValue'),
                          discountedPeriod.get('discountPercent'),
                          discountedPeriod.get('discountedAmount')
                        )
                      "
                      [attr.aria-label]="'discount-percent'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="surface-100 p-3 border-top-1 border-bottom-1 border-300">
        <p-button
          icon="fa fa-plus"
          [label]="'FREEDISCOUNT.BTN_ADD_MORE' | translate"
          styleClass="text-sm p-button-outlined surface-0"
          (click)="addDiscountedPeriod()"
        />
      </div>

      <div class="p-3">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'FREEDISCOUNT.DISCOUNT_REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          class="w-full text-sm h-4rem"
          [placeholder]="'FREEDISCOUNT.PLACE_REASON' | translate"
          formControlName="discountReason"
          [ngClass]="{
            'ng-invalid ng-dirty':
              discountedPeriodForm.get('discountReason').invalid &&
              discountedPeriodForm.get('discountReason').touched,
          }"
        >
        </textarea>
      </div>
      <!-- Modal Content -->

      <!-- Modal Footer -->
      <div
        class="surface-0 sticky left-0 bottom-0 w-full z-1 border-top-1 border-300 flex align-items-center justify-content-between p-3"
      >
        <p-button
          label="Cancel"
          (click)="closePopup()"
          styleClass="text-sm p-button-text"
        />
        <p-button
          [disabled]="
            !isDiscountedPeriodsValid() || !discountedPeriodForm.valid
          "
          [loading]="btnLoading | async"
          (click)="onSubmit()"
          [label]="'FREEDISCOUNT.BTN_APPLY' | translate"
          styleClass="text-sm"
        />
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Add Discounted Period Modal -->
